const cn = {
    commonProductPackage: {
        ip_free: 'ip_free_',
        ip_trial: '技术保护',
        ip_commercial_old: 'ip_commercial_old_',
        ip_commercial: 'ip_commercial_',
        material_trial: '新材料',
        material_commercial_old: 'material_commercial_old_',
        material_commercial: 'material_commercial_',
        air_free: 'air_free_',
        air_trial: '技术方案',
        air_commercial: 'air_commercial_',
        insights_trial: 'insights_trial_',
        insights_commercial: 'insights_commercial_',
    },
};

const en = {
    commonProductPackage: {
        ip_free: 'ip_free_',
        ip_trial: 'Eureka Search',
        ip_commercial_old: 'ip_commercial_old_',
        ip_commercial: 'ip_commercial_',
        material_trial: 'Eureka Materials ',
        material_commercial_old: 'material_commercial_old_',
        material_commercial: 'material_commercial_',
        air_free: 'air_free_',
        air_trial: 'Eureka Ideas',
        air_commercial: 'air_commercial_',
        insights_trial: 'insights_trial_',
        insights_commercial: 'insights_commercial_',
    },
};

const tw = {
    commonProductPackage: {
        ip_free: 'ip_free_',
        ip_trial: '技術保護',
        ip_commercial_old: 'ip_commercial_old_',
        ip_commercial: 'ip_commercial_',
        material_trial: '新材料',
        material_commercial_old: 'material_commercial_old_',
        material_commercial: 'material_commercial_',
        air_free: 'air_free_',
        air_trial: '技術方案',
        air_commercial: 'air_commercial_',
        insights_trial: 'insights_trial_',
        insights_commercial: 'insights_commercial_',
    },
};

const jp = {
    commonProductPackage: {
        ip_free: 'ip_free_',
        ip_trial: '技術保護',
        ip_commercial_old: 'ip_commercial_old_',
        ip_commercial: 'ip_commercial_',
        material_trial: '新素材',
        material_commercial_old: 'material_commercial_old_',
        material_commercial: 'material_commercial_',
        air_free: 'air_free_',
        air_trial: '技術ソリューション',
        air_commercial: 'air_commercial_',
        insights_trial: 'insights_trial_',
        insights_commercial: 'insights_commercial_',
    },
};

const messages = {
    cn, en, tw, jp,
};

export default messages;
